// Fetch list

export const FETCH = 'trailerEquipments.FETCH'
export const FETCH_FOR_MAP = 'trailerEquipments.FETCH_FOR_MAP'
export const FETCH_STARTED = 'trailerEquipments.FETCH_STARTED'
export const FETCH_FULFILLED = 'trailerEquipments.FETCH_FULFILLED'
export const FETCH_REJECTED = 'trailerEquipments.FETCH_REJECTED'
export const FETCH_CANCELLED = 'trailerEquipments.FETCH_CANCELLED'

export const SORTING_CHANGED = 'trailerEquipments.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'trailerEquipments.FETCH_ONE'
export const FETCH_ONE_STARTED = 'trailerEquipments.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'trailerEquipments.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'trailerEquipments.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'trailerEquipments.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'trailerEquipments.SAVE'
export const SAVE_STARTED = 'trailerEquipments.SAVE_STARTED'
export const SAVE_FULFILLED = 'trailerEquipments.SAVE_FULFILLED'
export const SAVE_REJECTED = 'trailerEquipments.SAVE_REJECTED'
export const SAVE_CANCELLED = 'trailerEquipments.SAVE_CANCELLED'
export const SAVE_DUPLICITY_FOUND = 'trailerEquipments.SAVE_DUPLICITY_FOUND'

// Delete

export const DELETE = 'trailerEquipments.DELETE'
export const DELETE_STARTED = 'trailerEquipments.DELETE_STARTED'
export const DELETE_FULFILLED = 'trailerEquipments.DELETE_FULFILLED'
export const DELETE_REJECTED = 'trailerEquipments.DELETE_REJECTED'
export const DELETE_CANCELLED = 'trailerEquipments.DELETE_CANCELLED'

// Clear

export const CLEAR = 'trailerEquipments.CLEAR'

// Export

export const EXPORT = 'trailerEquipments.EXPORT'
export const EXPORT_FULFILLED = 'trailerEquipments.EXPORT_FULFILLED'
